class InstagramFeed extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.domElements();
    this.handleCheckAppFeedExists();
    this.observeForFeed();
  }

  domElements() {
    this.placeHolderWrapper = this.querySelector(
      ".instagram-wrapper-placeholder"
    );
    this.feedWrapper = this.querySelector(".instagram-wrapper--feed");
  }

  handleCheckAppFeedExists() {
    const appFeed = this.querySelector("#insta-feed");
    if (appFeed && appFeed?.children?.length > 0) {
      this.handleHidePlaceHolder();
    } else {
      this.handleShowPlaceHolder();
    }
  }

  debounce(fn, delay) {
    let timer;
    return function (...args) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }

  handleObserverCallBack(mutations) {
    this.domElements();
    mutations.forEach(() => {
      const appFeed = this.querySelector("#insta-feed");
      if (appFeed && appFeed?.children.length > 0) {
        this.handleHidePlaceHolder();
      } else {
        this.handleShowPlaceHolder();
      }
    });
  }

  observeForFeed() {
    // Only watch if not present
    const checkElementExist = this.querySelector("#insta-feed");
    if (checkElementExist && checkElementExist.children?.length > 0) return;
    this.observer = new MutationObserver(
      this.debounce(this.handleObserverCallBack.bind(this), 300)
    );
    this.observer.observe(this, { childList: true, subtree: true });
  }

  handleShowPlaceHolder() {
    if (!this.placeHolderWrapper) {
      console.error("placeholder element not found");
      return;
    }

    this.placeHolderWrapper?.classList.remove(
      "instagram-wrapper-placeholder--hidden"
    );

    if (!this.feedWrapper) {
      console.error("feed element not found");
      return;
    }

    this.feedWrapper?.classList.add("instagram-wrapper-feed-hidden");
  }

  handleHidePlaceHolder() {
    if (!this.placeHolderWrapper) {
      console.error("placeholder element not found");
      return;
    }

    this.placeHolderWrapper?.classList.add(
      "instagram-wrapper-placeholder--hidden"
    );

    if (!this.feedWrapper) {
      console.error("feed element not found");
      return;
    }

    this.feedWrapper?.classList.remove("instagram-wrapper-feed-hidden");
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define("instagram-feed", InstagramFeed);
